<template>
	<div class="multiplication-box-method">
		<!-- <div class="line-operation">{{ operands.map(el=>read_notation(el)).join(" X ") }} = ?</div> -->
		<p>Let's use the
			<a 
			class="link-to-article link"
			href="https://mathskills4kids.com/box-method-multiplication-worksheets" target="_blank">box multiplication method</a> to solve it.
		</p>
		<div class="box-method-container">
			<div class="box-method-wrapper demonstration">
				<div v-for="operand in operands">{{operand}} = {{ decompose(operand).join(" + ") }}</div>
				<div class="box">
					<div class="sub-products">
							<table class="table">
								<thead>
									<tr>
										<th></th>
										<th :ref="`th-col`" :class="['th-fact th-col-' + (j + 2), 'cel-1-' + (j + 2)]" v-for="(it, j) in decompose(operands[0])" scope="col">
											<div class="position-relative fact-2">
												<div ref="col-number" class="number">{{ it % 1000 === 0 ? read_notation(it) : read_notation(it) }}</div>
											</div>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, i) in decompose(operands[1])">
										<th :ref="`th-row`" :class="[`th-fact th-row-${i + 2} cel-${i + 2}-1`]" scope="row">
											<div class="position-relative fact1">
												<div ref="row-number" class="number">{{ read_notation(item) }}</div>
											</div>
										</th>
										<td
											v-for="(it, j) in decompose(operands[0])"
											:class="[`border info-icon cel-${i + 2}-${j + 2} row-${i + 2} col-${j + 2}`]"
											@mouseover="hover(i, j)"
											@mouseleave="leave(i, j)"
											v-tooltip="tooltip(it, item)">
											<div class="number">{{ it * item % 1000 === 0 ? read_notation(it * item) : read_notation(it * item) }}</div>
										</td>
									</tr>
								</tbody>
								<tfoot>
									<tr>
										<td :colspan="1 + decompose(operands[0]).length">{{ operands.join(' x ') }} = </td>
									</tr>
								</tfoot>
							</table>
					</div>
					<div class="sum-products">
						<table class="table">
							<thead>
								<tr>
									<td>&nbsp;</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, i) in decompose(operands[1])">
									<td>
										<div class="position-relative">
											<div class="operator-sum-box" v-if="i == decompose(operands[1]).length - 1 && i != 0">+</div>
											<div>{{ read_notation(parseInt(operation.addition(decompose(operands[0]).map(el => el * item)))) }}</div>
										</div>
									</td>
								</tr>
								<tr>
									<td class="border-top">
										<div class="font-bold"><strong>{{ read_notation(result) }}</strong></div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	const $operations = require("../scripts/variables").operations;
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	// import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
	import { VTooltip, VClosePopper, Dropdown, Tooltip, Menu } from 'floating-vue'
	// import FloatingVue from 'floating-vue'
	import 'floating-vue/dist/style.css'

	export default {
		name: 'BoxMultiplication',
		mixins: [BaseExerciseMixin],
		directives: {
			tooltip: VTooltip,
			'close-popover': VClosePopper
		},
		components: { Tooltip, Dropdown, Menu },
		props: {
			fact:{type: Array, required: true},
		},
		data() {
			return {
				result: $operations.unknow(this.operator, this.fact),
				operands: this.fact.filterInt().sort_gt(),
				operation: $operations,
				msg: "bonjour"
			}
		},
		created(){
			let stepsResult = [], fact1 = parseInt(this.operands[0]), fact2 = parseInt(this.operands[1]), k = 0;
			for(let i = fact2.getLength(); i > 0; i--){
				let res = (fact1 * (fact2.getDigit(fact2.getLength() - k - 1)));
				if(res != 0){
					res = res.toString().split('');
				stepsResult.push(res);
				}else{
					res = res.toString().split('');
					for(let j = 0; j < fact1.getLength(); j++){
						res.push("0");
					}
				}
				for(let j = 0; j < k; j++){
					res.push("0");
				}
				k++;
			}
			this.result = fact1 * fact2;
			this.stepsResult = stepsResult;
		},
		methods:{
			decompose(n){
				let nbre = parseInt(n).toString(), res = [], l = nbre.length;
				for(let i = 0; i < l; i++){
					res.push(parseInt(nbre.charAt(i)) * Math.pow(10, l - i - 1));
				}
				return res;
			},
			hover(i, j){
				this.$refs[`row-number`][i].classList.add('hover-cel');
				this.$refs[`col-number`][j].classList.add('hover-cel');
			},
			leave(i, j){
				this.$refs[`row-number`][i].classList.remove('hover-cel');
				this.$refs[`col-number`][j].classList.remove('hover-cel');
			},
			tooltip(f1, f2) {
				return {
					content: `${this.read_notation(f1)} x ${this.read_notation(f2)} = ${f2 * f1}`,
					trigger: ['hover'],
					distance: -10
				}
			}
		}
	};
</script>
<style lang="scss" scoped>
	.multiplication-box-method{
		p{
			margin-top: 0;
			margin-bottom: 1rem;
		}
		.line-operation{}
		.box-method-container {
			text-align: center;
			.box-method-wrapper {
				display: inline-block;
			}
		}
		.box{
			border: 1px solid #dee2e6;
			margin-right: 0;
			margin-left: 0;
			padding: 4px;
			display: flex;
			width: fit-content;
			flex-wrap: nowrap;
			overflow-x: visible;
			margin: 1rem auto;

			.sub-products{
			    margin-right: 0.5rem;
				.hover-cel{
					// border: 1px solid blue!important;
					background-color: rgba(200, 200, 200, 0.5);
				}
				.th-fact {
					padding: 0.5rem 1rem;
					&.fact-1 {}
					&.fact-2 {}
				}
				table{
					width: 100%;
					margin-bottom: 1rem;
					color: #212529;
					border-collapse: collapse;
					font-size: 1em;
					tr{
						td,th{
							padding: 0.75rem;
							text-align: center;
							border-bottom:0;
							border-top:0;
							cursor: pointer;
							vertical-align: top;
						}
						td{

						}
					}
					tbody{
						td{
							border:3px solid #1e1e1e!important;
						}
					}
					tfoot{
						tr{
							td{
								padding: 0.75rem 0;
								text-align: right;
								padding-right: 0!important;
							}
						}
					}
					thead td{
						border:none;
					}
				}
				.fact1{
					border:none;
					text-align: center;
				}
				.operator-line{
					position:absolute;
					right: -1.4rem;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.operator-sum-box{
				position:absolute;
				left: -1.5rem;
				bottom: -0.75rem;
			}
			.operator-product-box{
				position:absolute;
				top: 75%;
				left: 50%;
				transform: translateX(-50%);
			}
			.sum-products{
				text-align: right;
				margin:0 0.25rem;
				table{
					width: 100%;
					margin-bottom: 1.3rem;
					color: #212529;
					border-collapse:collapse;
					padding: 0 0.5rem;
					font-size: 1em;
					tr{
						td,th{
							padding-top: calc(0.75rem + 1px);
							padding-bottom: calc(0.75rem + 1px);
							border:none;
						}
						.border-top{
						    border-top: 2px solid #343a40;
						}
					}
					tbody{
						td{
							// border:3px solid #1e1e1e!important;
						}
					}
				}
			}
		}
	}
</style>